import DOMPurify from "dompurify";
import { API_BASE_URL } from "./apiConfig";

const HELP_PURIFY_CONFIG: DOMPurify.Config = {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: [
        "allow",
        "allowfullscreen",
        "frameborder",
        "scrolling",
        "target",
        "rel",
        "referrerpolicy",
    ],
    ALLOWED_URI_REGEXP:
        /^(?:(?:https?:)?\/\/(?:www\.)?(?:youtube(?:-nocookie)?\.com|player\.vimeo\.com)\/|\/|mailto:|https?:)/i,
};

const RELATIVE_CMS_ASSET = 'src="/api/cms/assets';
const CMS_ASSET_PATH = "/api/cms/assets";

export function rewriteHelpCmsAssetUrls(html: string): string {
    if (!html || !html.includes(RELATIVE_CMS_ASSET)) {
        return html;
    }
    return html.split(RELATIVE_CMS_ASSET).join(`src="${API_BASE_URL}/api/cms/assets`);
}

export function stripNonCmsHelpImages(html: string): string {
    if (!html || !html.includes("<img")) {
        return html;
    }
    const container = document.createElement("div");
    container.innerHTML = html;
    container.querySelectorAll("img").forEach((img) => {
        const src = img.getAttribute("src") ?? "";
        if (!src.includes(CMS_ASSET_PATH) || src.includes("..")) {
            img.remove();
        }
    });
    return container.innerHTML;
}

export function sanitizeHelpHtml(html: string): string {
    return stripNonCmsHelpImages(rewriteHelpCmsAssetUrls(DOMPurify.sanitize(html, HELP_PURIFY_CONFIG)));
}

export function hideFailedHelpImages(root: ParentNode): void {
    root.querySelectorAll("img").forEach((img) => {
        img.addEventListener(
            "error",
            () => {
                const parent = img.parentElement;
                img.remove();
                if (
                    parent
                    && parent.tagName === "P"
                    && parent.childElementCount === 0
                    && !parent.textContent?.trim()
                ) {
                    parent.remove();
                }
            },
            { once: true },
        );
    });
}
